import Sections from 'pages/LandingPage/Sections/Sections';

export default Sections;
